import React from "react";
import BlogsComp from "../components/Blogs/BlogsComp";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const Blogs = () => {
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const theme = useSelector((state) => state.theme.theme); // Assuming 'theme' holds 'dark' or 'light'
  const isDarkTheme = theme === "dark";
  const themeClasses = isDarkTheme
    ? "bg-black text-white"
    : "bg-white text-black";
  return (
    <div className={`min-h-screen xl:px-36 pt-14 ${themeClasses}`}>
      <BlogsComp />
    </div>
  );
};

export default Blogs;
